// extracted by mini-css-extract-plugin
module.exports = {"oauth_button":"FacebookAuth_oauth_button__dOFQN","waveHidden":"FacebookAuth_waveHidden__Dm0q5","wave":"FacebookAuth_wave__OicBw"};